import { Controller } from "@hotwired/stimulus"
import { Offcanvas } from "bootstrap"

export default class extends Controller {
  close() {
    Offcanvas.getInstance(this.element)?.hide()
  }

  disconnect() {
    this.close()
  }
}
